<template>
    <svg
        class="iconfont-js"
        :style="{ 'font-size': size + 'px', color: getColor }"
        aria-hidden="true"
    >
        <use :xlink:href="iconClass"></use>
    </svg>
</template>

<script>
export default {
    name: 'IconFont',
    props: {
        //图标的名称
        icon: {
            type: String,
            required: true,
        },
        //图标的font-size，单位是px
        size: {
            type: String,
            default: '16',
        },
        path: {
            type: String,
            default: '/',
        },
    },
    computed: {
        iconClass() {
            return `#${this.icon}`;
        },
        getColor() {
            return this.$route.path.indexOf(this.path) !== -1
                ? this.path === '/'
                    ? this.$route.path === '/'
                        ? '#E5131A'
                        : '#c2c2c2'
                    : '#E5131A'
                : '#c2c2c2';
        },
    },
};
</script>

<style>
.iconfont-js {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    color: #c2c2c2;
}
</style>
